import _ from 'lodash';
import minimatch from 'minimatch';

const replaceParamByStar = route =>
  _.split(route, '/')
    .map(part => (part.startsWith(':') ? '*' : part))
    .join('/');

export default (func, req) =>
  _.includes(_.castArray(func.method), req.method) &&
  minimatch(req.url, replaceParamByStar(func.route)) &&
  (func.exclude ? !minimatch(req.url, func.exclude) : true);
